import { ComplaintOrigin } from "./../interfaces/complaint-origin";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { CommonResponse } from "../interfaces/home";

@Injectable({
  providedIn: "root",
})
export class CompaniesService {
  baseUrl = environment.baseUrl + "Company/";

  constructor(private http: HttpClient) {}

  getAll(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl);
  }

  getByID(id: number): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl + id);
  }

  getByName(name: string): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl + "/name/" + name);
  }

  create(data: any) {
    return this.http.post(this.baseUrl, data);
  }

  delete(id: number) {
    return this.http.delete(this.baseUrl + id);
  }

  update(id: any, data: any) {
    return this.http.put(this.baseUrl + id, data);
  }
}
